import { render } from "./ReceiveCheck.vue?vue&type=template&id=27006fe0&scoped=true"
import script from "./ReceiveCheck.vue?vue&type=script&lang=js"
export * from "./ReceiveCheck.vue?vue&type=script&lang=js"

import "./ReceiveCheck.vue?vue&type=style&index=0&id=27006fe0&scoped=true&lang=css"

import exportComponent from "D:\\projects\\wmsapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27006fe0"]])

export default __exports__